import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
    selector: 'app-accordion-categories',
    imports: [NgFor, NgIf, DynamicModule, StoryblokDirective, NgClass],
    templateUrl: './accordion-categories.component.html',
    styleUrl: './accordion-categories.component.scss'
})
export class AccordionCategoriesComponent implements OnChanges {
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;
  @Input() groups: any;
  @Input() all_label!: string;
  _filter: string | undefined;
  _filteredGroups: any;
  components: any;

  ngOnChanges(changes: SimpleChanges): void {
    this.groups = this.groups.filter((x: any) => x.accordions.length > 0);
  }

  constructor() {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  filter(filter?: string | undefined) {
    if (!filter) {
      delete this._filter;
      delete this._filteredGroups;
    } else if (this._filter == filter) {
      delete this._filter;
      delete this._filteredGroups;
    } else {
      this._filter = filter;
      this._filteredGroups = this.groups.filter(
        (group: any) => group.title == filter
      );
    }
  }
}
